import React, { Component } from 'react';
import SearchBar from '../CommonComponents/SearchBar';
import SearchIcon from '../assets/icons/search.svg';
import AddIcon from '../assets/icons/add.svg';
import CheckBox from '../assets/icons/check_box_unchecked.svg';
import SelectedCheckBox from '../assets/icons/check_box_checked.svg';
import { RandomizedUserBadgeColors } from '../constants';
import ThemedButton from '../CommonComponents/ThemedButtons';
import { api } from '../utils';
import { AgentList, SelectedAgentData } from './model';
import AddingNewUser from './AddingNewUser';
import Modal from '../CommonComponents/Modal';

type Props = {
  onSelection: Function;
  botId: string;
  notification: Function;
  addNewUser: Function;
  closeAddNewUser: boolean;
  closeModals: Function;
  action: string;
  SelectedAgentData: SelectedAgentData[];
  tenantId: number;
  queueName: string;
};

type State = {
  searchTerm: string;
  userList: {
    userName: string;
    email: string;
    queues: string;
    id: number;
    check: boolean;
    botId: string;
    agentId: string;
  }[];
  addNewUser: boolean;
};

export default class AddUserList extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = this.setInitialState();
    this.selectedAgent = this.selectedAgent.bind(this);
    this.fetchAgentList = this.fetchAgentList.bind(this);
  }
  setInitialState(): State {
    return {
      searchTerm: '',
      userList: [],
      addNewUser: false,
    };
  }
  componentDidMount() {
    let promise = new Promise((resolve, reject) => {
      this.fetchAgentList(resolve);
    });
    promise.then((res) => {
      if (res === 'Success') {
        if (this.props.SelectedAgentData) {
          this.props.SelectedAgentData.map((data: SelectedAgentData, i: number) => {
            this.setState((prevState) => ({
              userList: prevState.userList.map((obj) =>
                obj.userName === data.name && obj.email === data.email
                  ? Object.assign(obj, { check: true })
                  : obj
              ),
            }));
          });
        }
      }
    });
  }

  fetchAgentList(resolve: Function) {
    let encodedbotId = encodeURIComponent(this.props.botId);
    api(
      `getAgentsList?botId=${encodedbotId}&tenantId=${this.props.tenantId}&tabName=queue&action=${this.props.action}&queueName=${this.props.queueName}`
    ).then((response) => {
      this.setState(
        {
          userList: response.agents.map((res: any, index: any) => ({
            userName: res.userName,
            email: res.EmailId,
            queues: res.currentQuest,
            id: index,
            check: false,
            botId: res.botId,
            agentId: res.AgentId,
          })),
        },
        () => {
          resolve('Success');
        }
      );
    });
  }
  selectedAgent() {
    let checkedData = this.state.userList.filter((data) => {
      return data.check === true;
    });
    this.props.onSelection(checkedData);
  }
  get UserDetails() {
    const searchTerm = this.state.searchTerm.toLowerCase();
    localStorage.setItem('searchTermuserListOfQueuesTab', searchTerm);
    return this.state.userList.filter(
      (filterData) => filterData.userName.toLowerCase().indexOf(searchTerm) >= 0
    );
  }
  toggleUserCheck = (userData: any) => {
    this.setState((prevState) => ({
      userList: prevState.userList.map((obj) =>
        obj.id === userData.id ? Object.assign(obj, { check: !userData.check }) : obj
      ),
    }));
  };
  render() {
    return (
      <div style={{ width: '650px' }}>
        <SearchBar
          placeholder='Search users'
          icon={SearchIcon}
          importedImg='yes'
          onSearch={(term: any) => {
            this.setState({
              searchTerm: term,
            });
          }}
        />
        <div className='add-user-list'>
          {this.UserDetails.length > 0 ? (
            <div className='header-wrapper'>
              <div className='header-content'>USER</div>
              <div className='header-content'>CURRENT QUEUES</div>
            </div>
          ) : (
            <></>
          )}

          <div className='content-wrapper' style={{ minHeight: '305px' }}>
            {this.UserDetails.length > 0 ? (
              this.UserDetails.map((userData, index) => {
                return (
                  <div className='content-sub-wrapper' key={index}>
                    <div className='frst-wrapper'>
                      <div
                        key={index}
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          this.setState((prevState) => ({
                            userList: prevState.userList.map((obj) =>
                              obj.id === userData.id
                                ? Object.assign(obj, { check: !userData.check })
                                : obj
                            ),
                          }));
                        }}>
                        <img
                          src={userData.check ? SelectedCheckBox : CheckBox}
                          alt='checkbox'
                        />
                      </div>
                      <div
                        style={{
                          backgroundColor:
                            RandomizedUserBadgeColors[
                              userData.userName[0].toLocaleLowerCase().charCodeAt(0) % 97
                            ],
                        }}
                        className='user-badge'>
                        {userData.userName[0]}
                      </div>
                      <div className='user-details'>
                        <span style={{ textTransform: 'capitalize' }}>
                          {userData.userName}
                        </span>
                        <span className='break-data'>{userData.email}</span>
                      </div>
                    </div>
                    <div>{userData.queues}</div>
                  </div>
                );
              })
            ) : (
              <div
                style={{
                  fontSize: '12px',
                  color: 'rgba(0,0,0,0.6',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'fixed',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                }}>
                {localStorage.getItem('searchTermuserListOfQueuesTab') !== '' ? (
                  <>No users found</>
                ) : (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: 'max-content',
                    }}>
                    <span>
                      All users on this tenant are already added to this queue/ bot.
                    </span>
                    <span>Click ‘Add a new user’ to add new users to the tenant.</span>
                  </div>
                )}
              </div>
            )}
          </div>
          <div
            style={{
              marginTop: '15px',
              display: 'flex',
              justifyContent: 'space-between',
            }}>
            <div
              style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
              onClick={() => {
                this.props.closeModals(true);
              }}>
              <img src={AddIcon} alt='add icon' />
              <span style={{ fontSize: '14px', fontWeight: 600, color: ' #6c7ef2' }}>
                Add a new user
              </span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <ThemedButton
                title='Done'
                theme='4'
                onClick={() => {
                  this.selectedAgent();
                }}
              />
            </div>
          </div>
        </div>
        <Modal
          isOpen={this.props.closeAddNewUser}
          title='Add agent'
          onClose={() => {
            this.props.closeModals(false);
          }}>
          <AddingNewUser
            addNewUser={this.props.addNewUser}
            onClose={() => {
              this.props.closeModals(false);
            }}
            selectedBotId={this.props.botId ? this.props.botId : ''}
          />
        </Modal>
      </div>
    );
  }
}
